import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ssupTheme } from "@storyworm/ssup-ui";
import { SsupDataProvider } from "@storyworm/ssup-data/react";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@storyworm/portal-docs/styles.css";
import { App } from "./App";
import { db } from "./services/firebase.service";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

// One QueryClient for the app; SsupDataProvider injects the SSUP Firestore
// handle so the shared @storyworm/ssup-data/react hooks resolve it via context.
// The shared ssupTheme + CssBaseline make the portal read as the same product
// as the admin console.
const queryClient = new QueryClient();

createRoot(container).render(
  <StrictMode>
    <ThemeProvider theme={ssupTheme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <SsupDataProvider db={db}>
          <App />
        </SsupDataProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
